// extracted by mini-css-extract-plugin
export default {"gradientText":"Page_gradientText__nsY0I","gradientTextSecondary":"Page_gradientTextSecondary__M6kGl","Page":"Page_Page__pDuKI"};